import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import service from '../service';
import type { Order, PaymentIntentCreateResponse } from '@Types/toast';

export type FishDetails = {
  fName: string;
  lName: string;
  email: string;
  phoneNumber: string;
};

export type CreatePaymentIntentVariables = {
  fishDetails: FishDetails;
  order: Order;
  productDescription: string;
  restaurantGuid: string;
  cardFishId?: string;
};

export function useCreatePaymentIntent(
  options: Omit<
    UseMutationOptions<
      PaymentIntentCreateResponse,
      Error,
      CreatePaymentIntentVariables
    >,
    'mutationKey' | 'mutationFn'
  > = {},
) {
  return useMutation({
    mutationKey: ['paymentIntent', 'create'],
    mutationFn: async (vars: CreatePaymentIntentVariables) => {
      const { fishDetails, order, productDescription, restaurantGuid, cardFishId } =
        vars;

      if (!fishDetails || !order || !productDescription || !restaurantGuid) {
        throw new Error(
          'Missing required fields: fishDetails, order, productDescription, restaurantGuid',
        );
      }

      if (!fishDetails.email) {
        throw new Error('Fish email is required');
      }

      const res = await service.createPaymentIntent(
        fishDetails,
        order,
        productDescription,
        restaurantGuid,
        cardFishId,
      );

      if (!res) {
        throw new Error('Failed to create payment intent');
      }

      return res;
    },
    retry: 1,
    ...options,
  });
}
